/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable react/no-array-index-key */
import React, { Component } from 'react';
import moment from 'moment';
import LazyLoad from 'react-image-lazy-load';
import { sortByKey, totalValue, totalHeight } from 'lib/services';
import Popover from 'react-simple-popover';
import ReactHtmlParser from 'react-html-parser';
import { fraction } from 'mathjs';
import { PlusIcon, SubIcon } from '../recipeList/RecipeData'

let c = ""

export const DeletePopup = props => {
  const { recipeData, popupIndex, recipeIndex } = props
  return (
    <div className="modal fade in del-rcp" style={{display: 'block'}}>
      <div className="modal-content">
        <div className="add-feedback">
          <p> Are you sure want to delete this recipe?</p>
          <div className="nxt-stp">
            <button 
              type="button" 
              className="skip-feedback" 
              onClick={()=>props.cancelDelete(recipeData, popupIndex)}
            > 
                Cancel
            </button>
                
            <button 
              type="button"
              className="btn btn-success create plan" 
              onClick={()=>props.deleteRecipe(popupIndex, recipeIndex, recipeData.items.recipe.recipe_id )}
            > 
              Yes, Delete It
            </button>  
          </div>
        </div>
          
      </div>
    </div>
  )
}
class RecipeForWeekCalendar extends Component {
  constructor(props) {
    super(props)
    const vRData = this.props.vRData || { }
    this.state = {
      ...props,
      params: {},
      recipeData: {},
      showRecipePopup: false,
      popupIndex: -1,
      clickInstructionAccordion: vRData.clickInstructionAccordion || false,
      clickIngredientAccordion: vRData.clickIngredientAccordion || false,
      showInstructions: vRData.showInstructions || false,
      showIngredients: vRData.showIngredients || false,
      // servingSize: props.defaultServingSize,
      showDelete: false,
      showEdit: false,
      message: "",
      updatedServing: props.defaultServingSize,
    }
  }

 
  // eslint-disable-next-line
  UNSAFE_componentWillReceiveProps(props) {

    const vRData = props.vRData || { }
    const { showEdit } = this.state
    this.setState({...props })
    if(vRData && vRData.popupIndex !== undefined){
      
      this.setState({ 
        // servingSize: props.defaultServingSize, 
        showRecipePopup: vRData.showRecipePopup || false,
        popupIndex: vRData.popupIndex ,
        clickInstructionAccordion: vRData.clickInstructionAccordion || false,
        clickIngredientAccordion: vRData.clickIngredientAccordion || false,
        showInstructions: vRData.showInstructions || false,
        showIngredients: vRData.showIngredients || false,
        recipeData: vRData.recipeData || {},
      })
    }
    if(vRData && vRData.servSize !== undefined){
      this.setState({ updatedServing: vRData.servSize })
    }
    if(props.textMessage && showEdit) {
      // const updatedServing = vRData.updatedServing  ? vRData.updatedServing : vRData.recipeData.servingSize
      this.setState({ message:"Servings Updated"})
      setTimeout(()=>this.setState({ message:"", showEdit: false}), 1000)
    }
    
    // if()
  }

  // eslint-disable-next-line`  
  onDrop(event,recipe,cDate,type, length, dropIndex) {
    event.preventDefault();
    const { fDate, params, inputs, recipeArr } = this.state
    c = ""
    params.to_date = cDate.cooking_date

    params.user_weekly_schedule_id = inputs.user_weekly_schedule_id
    // length = length === 1 && params.from_date === cDate.cooking_date ? 0 : length
    
    const dragRIndex = params.index
    
    if(type === "new") {
      const newEle = document.getElementsByClassName(`add-rcp meal-post ${cDate.cooking_date} ${length}`)[0]
      const preEle = document.getElementsByClassName('testio')[0]
      if(newEle){
        newEle.style.background = "#fff"
        newEle.children[0].style.margin = '0px'
        c=""
        newEle.classList.remove('empty-rcp')
      }
      if(preEle) {
        preEle.style.display = "none"
      }
    }
    const res = document.getElementsByClassName('rcp-drg')[0]
    res.classList.remove('rcp-drg')
    recipeArr[dragRIndex].priority_order = type ==="new" ? length.toString()  : recipe.priority_order
    if(type !== "new") {
      const rIndex = recipeArr.findIndex(x=>x.cooking_date === cDate.cooking_date && x.items.recipe.recipe_id === recipe.items.recipe.recipe_id)
      // alert(dropIndex)
      const childEle = document.getElementsByClassName(`testio ${cDate.cookking_date}${rIndex}`)[0]
      if(childEle) {
        childEle.style.display = "none";
      }
      this.onDragLeaveEvent(event,cDate.cooking_date, dropIndex)
    }
    // recipeArr[dragRIndex].entry = "new"
    
    // if(cDate.cooking_date !== params.from_date)
    recipeArr[dragRIndex].cooking_date = cDate.cooking_date

    params.modify_to_recipe = []
    params.modify_from_recipe = []
    
    let flength = 0
    let tlength = 0
    let glength = 0
    
    params.add_recipe = {
      priority_order: parseInt(recipeArr[dragRIndex].priority_order,10),
      recipe_id: recipeArr[dragRIndex].items.recipe.recipe_id
    }
  

    
    let itemIndex = -1
    if(recipeArr[dragRIndex].priority_order) {
      
      // alert(recipeArr[dragRIndex].priority_order)
      recipeArr.map((item,ind)=>{
        if(item.cooking_date === params.to_date ) {
          if(params.from_date !== params.to_date ) {
            
            if(parseInt(recipeArr[dragRIndex].priority_order,10) > parseInt(item.priority_order,10)){
              item.priority_order = tlength
              item.priority_order = item.priority_order.toString()
              tlength += 1
            } else if(parseInt(recipeArr[dragRIndex].priority_order,10) === parseInt(item.priority_order,10)) {
              if(dragRIndex !== ind) {
                item.priority_order = parseInt(recipeArr[dragRIndex].priority_order,10) + 1 
                item.priority_order = item.priority_order.toString()
              }
            } 
            else if(parseInt(recipeArr[dragRIndex].priority_order,10) < parseInt(item.priority_order,10)) {
              item.priority_order = parseInt(item.priority_order,10) + 1
              item.priority_order = item.priority_order.toString()
              // tlength +=1
            }
          } else if(params.from_date === params.to_date ) {
            if(parseInt(recipeArr[dragRIndex].priority_order,10) > parseInt(item.priority_order,10)){
              item.priority_order = tlength
              item.priority_order = item.priority_order.toString()
              tlength += 1
              glength += 1
            } 
            // else if(parseInt(recipeArr[dragRIndex].priority_order,10) === parseInt(item.priority_order,10)
            // ) {
              
            //   if(dragRIndex !== ind && parseInt(item.priority_order,10) !== 0) {
            //     if(dragRIndex < dropIndex && dropIndex !== ind) {
            //       item.priority_order = parseInt(recipeArr[dragRIndex].priority_order,10) -1
            //     } if(dragRIndex > dropIndex && dropIndex <= ind){
            //       item.priority_order =  parseInt(recipeArr[dragRIndex].priority_order,10) +1
            //     }
            //   } else if(dragRIndex !== ind && item.priority_order === '0'){
            //     item.priority_order =  parseInt(item.priority_order,10) + 1
            //   }
            //   item.priority_order = item.priority_order.toString()
            // } 
            else if(dragRIndex > dropIndex && parseInt(recipeArr[dragRIndex].priority_order,10) <= parseInt(item.priority_order,10) && dragRIndex !== ind ) {
              // if(dragRInd?ex < dropIndex && dropIndex <=ind)
              item.priority_order =  glength + 1 
              // else if (dragRIndex > dropIndex) {
              //   item.priority_order =  parseInt(item.priority_order,10) 
              // }
              item.priority_order = item.priority_order.toString()
              glength +=1
            }
          }
          
          params.modify_to_recipe.push({ recipe_id: item.items.recipe.recipe_id, priority_order: item.priority_order })
          if(dragRIndex === ind) {
            itemIndex = params.modify_to_recipe.length
          }
        }
    
        if(item.cooking_date === params.from_date && params.from_date !== params.to_date) {
          item.priority_order = flength
          item.priority_order = item.priority_order.toString()
          params.modify_from_recipe.push({ recipe_id: item.items.recipe.recipe_id, priority_order: item.priority_order })
          flength +=1;
        }
        return null;
      })
    }
    if(params.from_date === params.to_date && (dragRIndex < dropIndex || type === "new") ){
      recipeArr[dragRIndex].priority_order = parseInt(recipeArr[dragRIndex].priority_order,10) === 0 ? 0: parseInt(recipeArr[dragRIndex].priority_order,10)  - 1 
      recipeArr[dragRIndex].priority_order = recipeArr[dragRIndex].priority_order.toString()
      if(itemIndex > -1) {
        params.modify_to_recipe[itemIndex-1].priority_order =  recipeArr[dragRIndex].priority_order
      }
    }
    // alert(itemIndex)
    
    tlength = 0
    params.index = -1
    this.setState({ recipeArr, params })
    if(this.state.crt.parentNode)
      this.state.crt.parentNode.removeChild(this.state.crt);
    this.props.onDrop(recipeArr, fDate, params)
  }

  // eslint-disable-next-line
  dragCapture(event) {
    event.dataTransfer.effectAllowed = 'copyMove';
    event.dataTransfer.dropEffect = 'move';
    event.preventDefault();
  }

  // eslint-disable-next-line
  startDrag(event, recipe, cDate, rIndex) {
    const { params } = this.state
    const element = document.getElementsByClassName(`meal-post ${cDate.cooking_date}${rIndex}`)[0]
    const crt = element.cloneNode(true);
    // const dataEle = browserName !== "Firefox" ? crt : element
    params.from_date = cDate.cooking_date
    params.index = rIndex
    params.priority_order = event.target.id
    params.from_recipe_id = recipe.items.recipe.recipe_id
    event.target.style.background = '#E9E9E9';
    event.target.classList.add ('rcp-drg')
    const ele = document.getElementsByClassName('rcp-drg')[0]
    // event.target.style.opacity = 1;
    // ele.children[0].style.visibility = "hidden"; 
    ele.style.background = "#E9E9E9"; 
    event.dataTransfer.setData('html', crt);
    // crt.style.opacity = 1
    // crt.style.display =
    crt.classList.add('hidden-drag-ghost');
    event.dataTransfer.effectAllowed = 'move';
    event.dataTransfer.dropEffect = 'move';
    event.target.appendChild(crt);
    event.dataTransfer.setDragImage(crt, 0, 121);
    this.setState({
      target: event.target,
      crt
    });
    if(document.getElementsByClassName(`add-rcp meal-post ${cDate.cooking_date}`)[0])
      document.getElementsByClassName(`add-rcp meal-post ${cDate.cooking_date}`)[0].classList.add('empty-rcp')
  }

  onDragEnd(event,cDate, rIndex) {
    const { target, params } = this.state
    const ele = document.getElementsByClassName(`meal-post ${cDate}${rIndex}`)[0]
    const elem = document.getElementsByClassName(`meal-post${cDate}${rIndex}`)[0]
    const childElem = document.getElementsByClassName(`testio ${cDate}${rIndex}`)[0]
    
    elem.style.visibility = "visible"; 
    ele.style.display = "block"; 
    target.style.background = '#fff'
    ele.style.background = '#fff'
    ele.style.height =  '156px';
    ele.style.minHeight =  '156px';
    childElem.style.display = "none"
    if(c !== '' ) {
      const preEle = document.getElementsByClassName(`meal-post ${c}`)[0]
      const preChildEle = document.getElementsByClassName(`testio ${c}`)[0]
      if(preEle) {
        preEle.style.background =  '#fff';
        preEle.style.height =  '156px';
      }
      if(preChildEle) {
        preChildEle.style.display = "none"
      }
    }
    const dragEle = document.getElementsByClassName('rcp-drg')[0]
    if(dragEle) {
      dragEle.style.display = "block"
    }
    if(this.state.crt.parentNode)
      this.state.crt.parentNode.removeChild(this.state.crt);

    c = ""
    params.index = -1
    this.setState({ params })
  }

  // eslint-disable-next-line
  stopDrag(event) {
    event.stopPropagation();
  }

  // recipe drag capture event
  dropEffect(event,cDate,rIndex){
    
    event.preventDefault();
    const addEle = document.getElementsByClassName(`testio ${cDate}${rIndex}`)[0]
    const ele = document.getElementsByClassName(`meal-post ${cDate}${rIndex}`)[0]
    const childEle = document.getElementsByClassName(`meal-post${cDate}${rIndex}`)[0]
    const dragEle = document.getElementsByClassName(`rcp-drg`)[0]
    const { params } = this.state
    if(dragEle)
      dragEle.style.display = "none"
    if(params.from_date !== cDate) {
      if(c !== `${cDate}${rIndex}`) {
        addEle.style.display = 'block';
        ele.style.height = '320px';
        
        addEle.style.height = '156px';
        addEle.style.background = '#EFEFEF';
        addEle.style.marginBottom = '6px';
        childEle.style.background = '#fff';
        c = `${cDate}${rIndex}`
      } else if(c === `${cDate}${rIndex}`){
        const preEle = document.getElementsByClassName(`meal-post ${c}`)[0]  
        const preChildEle = document.getElementsByClassName(`testio ${c}`)[0]  
        preChildEle.style.display = 'none';
        preEle.style.height = '156px'
        c= ""
      }
    } 
    else if(params.from_date === cDate){
      if(c !== `${cDate}${rIndex}`) {
        addEle.style.display = 'block';
        ele.style.height = '320px';
        ele.style.background = '#fff';
        
        addEle.style.height = '156px';
        addEle.style.background = '#EFEFEF';
        addEle.style.marginBottom = '6px';
        childEle.style.background = '#fff';
        c = `${cDate}${rIndex}`
      } else if(c!=="") {
        const preEle = document.getElementsByClassName(`meal-post ${c}`)[0]  
        const preChildEle = document.getElementsByClassName(`testio ${c}`)[0]  
        preChildEle.style.display = 'none';
        addEle.style.display = 'none';
        preEle.style.height = '156px'
        c= ""
      }
    }
    if(params.index === rIndex) {
      ele.style.height = '156px'
      ele.style.background = '#EFEFEF';
      childEle.style.visibility="hidden"
      addEle.style.display = 'none';
      if(dragEle)
        dragEle.style.display = "block"
    }
  }
  // eslint-disable-next-line
  dragLeaveEvent(event,cDate,rIndex){
    const addEle = document.getElementsByClassName(`testio ${cDate}${rIndex}`)[0]
    addEle.style.display = 'none';
    
    const ele = document.getElementsByClassName(`meal-post ${cDate}${rIndex}`)[0]
    // const childEle = document.getElementsByClassName(`meal-post${cDate}${rIndex}`)[0]
    ele.style.height = '156px';
    // c = ""
  }

  // eslint-disable-next-line
  addDragCapture(event,cDate,rIndex){
    const ele = document.getElementsByClassName(`add-rcp meal-post ${cDate} ${rIndex}`)[0]
    ele.style.background =  '#E9E9E9';
    ele.classList.add('empty-rcp')
    
    if(`add-rcp meal-post ${cDate} ${rIndex}` !== c ) {
      if(c !== '') {
        const preEle = document.getElementsByClassName(`meal-post ${c}`)[0]
        const preChildEle = document.getElementsByClassName(`testio ${c}`)[0]
        if(preEle) {
          preEle.style.height =  '156px';
          if(preChildEle)
            preChildEle.style.display =  'none';
        }
      }
    }
    const dragEle = document.getElementsByClassName('rcp-drg')[0]
    if(dragEle) {
      dragEle.style.display = "none"
    }
    c = `${cDate} ${rIndex}`
    if(this.state.crt.parentNode)
      this.state.crt.parentNode.removeChild(this.state.crt);
  }
 
  //  empty space recipe event
  // eslint-disable-next-line 
  addDragLeaveEvent(event,cDate, rIndex) {
    const ele = document.getElementsByClassName(`add-rcp meal-post ${cDate} ${rIndex}`)[0]
    ele.style.background =  '#fff';
    ele.classList.remove('empty-rcp')
    c = ""
  }
 
  // recipe drag leave event
  onDragLeaveEvent(event,cDate, rIndex) {
    const { params } = this.state
    
    const ele = document.getElementsByClassName(`meal-post ${cDate}${rIndex}`)[0]
    const elem = document.getElementsByClassName(`meal-post${cDate}${rIndex}`)[0]
    const childEle = document.getElementsByClassName(`testio ${cDate}${rIndex}`)[0]
    if(childEle) {
      childEle.style.display = "none";
    }
    if(params.from_date !== cDate) {
      ele.style.background = '#fff'      
      ele.style.height =  '156px';
      elem.style.visiblity =  'visible';
    } else if(params.index !== rIndex){
      ele.style.background = '#fff'
      ele.style.height =  '156px';
      elem.style.visiblity =  'visible';
      
    } else if(params.index === rIndex){
      const element = document.getElementsByClassName('rcp-drg')[0]
      if(element){
        element.style.minHeight =  '156px';
        element.style.height =  '156px';
        element.style.display =  'block';
      }
    }
    
    c= ""
    const dragEle = document.getElementsByClassName('rcp-drg')[0]
    if(dragEle) {
      dragEle.style.display = "block"
      dragEle.style.height = "156px"
      if(dragEle.children[0]) {
        // dragEle.children[0].style.display = "none"
      }
    }
    ele.classList.remove('rcp-drg')
  }

  showRecipe(recipe, showRecipePopup,rIndex){
    if(this.state.popupIndex === -1){
      const rData = { 
        recipeData: recipe, showRecipePopup, popupIndex: rIndex,
        showIngredients: false, showInstructions: false, clickIngredientAccordion: false, clickInstructionAccordion: false
      }
      this.setState({ recipeData: recipe, showRecipePopup: true, popupIndex: rIndex, showDelete: false, updatedServing: recipe.servingSize })  
      this.props.closePopup(rData)
    }
  }

  clickAccordion(value){
    const { clickAccordion } = this.state
    let { showIngredients, showInstructions, showNutrition, clickIngredientAccordion, clickInstructionAccordion, clickNutritionAccordion } = this.state;
    if(value === 'ingredients') {
      showIngredients = !showIngredients
      clickIngredientAccordion = !clickIngredientAccordion
    } else if(value === 'instructions') {
      showInstructions = !showInstructions
      clickInstructionAccordion = !clickInstructionAccordion
    } else if(value === 'nutrition') {
      showNutrition = !showNutrition
      clickNutritionAccordion = !clickNutritionAccordion
    }
    this.setState({ 
      clickAccordion: !clickAccordion,
      showNutrition,
      showIngredients,
      showInstructions,
      clickIngredientAccordion,
      clickInstructionAccordion,
      clickNutritionAccordion,
    });
  }
  
  // get list of recipe data
  viewPlan() {
    const { cookingDate, popupIndex, showDelete, showIngredients, showInstructions } = this.state
    let { recipeArr, showRecipePopup } = this.state
    const recipeIds = []
    showRecipePopup = !showDelete
    if(showRecipePopup && popupIndex !== -1) {
      document.body.style.overflow = "hidden"
    } else {
      document.body.style.overflow = "auto"
    }
    const rlen = totalHeight(recipeArr)
    recipeArr.map((recipe)=>recipeIds.push({id:recipe.items.recipe.recipe_id, size: recipe.servingSize}))
    return(
      <div className="row">
        {
          cookingDate.map((cDate, index)=>{
            const cDay = moment(cDate.cooking_date).format('ddd')
            const cookDate = moment(cDate.cooking_date).format('DD')
            const lastIndexClass = cookingDate.length - 1 === index ? "rcp-no-brdr" : "rcp-brdr"
            const notesDate = moment(cDate.cooking_date).format('YYYY-MM-DD')
            const mode = cDate.notes !== null && cDate.notes !== undefined ? 'edit' :'add'
            recipeArr = recipeArr.sort(sortByKey('priority_order','asc'))
            let length = 0
            const position = index < 4 ? 'right' : 'left'
            
            return(
              <div className="week-dsply" key={cDay}>
                <div className="days-prt">
                  <span>{cDay}</span>
                  <span className="bold-cDate">{cookDate}</span>
                </div>
                <div className={lastIndexClass} style={{ height: `${rlen*165}px`, minHeight:'450px'}}>
                  <div className="rcp-prt">
                    {
                      recipeArr.map((recipe,rIndex)=>{
                        
                        const pos = length > 0 ? (window.scrollY/(length*157)) > 2 ? '60px' : '-5px' : '40px'
                        let topMargin = length === 0 && window.scrollY < 100 ? "80px" :  `${pos}`  
                        topMargin = showIngredients || showInstructions ?  "0px" :  topMargin  
                        
                        const margin = position === 'right' ? `${topMargin} 12px` : `${topMargin} 0 0px -8px`
                        let style = {padding:'0', width:'360px',float:'left',  boxShadow:'none', background:'transparent', display:'block'}
                        style = showIngredients || showInstructions ? 
                          {padding:'0', width:'360px', float:'left',  boxShadow:'rgba(0, 0, 0, 0.2) 0px 11px 15px -7px, rgba(0, 0, 0, 0.12) 0px 9px 46px 8px, rgba(0, 0, 0, 0.14) 0px 24px 38px 3px', background:'#fff', display:'block', top:'100px',position:'fixed'}
                          : style
                        const containerStyle = {borderRadius: '8px',background:'#fff', padding: 0, 	boxShadow: '0 11px 15px -7px rgba(0,0,0,0.2), 0 9px 46px 8px rgba(0,0,0,0.12), 0 24px 38px 3px rgba(0,0,0,0.14)', margin, top:'78px!important'}
                        
                        // if(recipeIds.length < recipeArr.length){
                        //   recipeIds.push({id:recipe.items.recipe.recipe_id, size: recipe.servingSize})
                        // }
                        if(cDate.cooking_date === recipe.cooking_date){
                          
                          const border = rIndex === popupIndex ? '2px solid #00C853' : '0'
                          
                          const rcpImg = recipe.items.recipe.image
                          let sideName = ""
                          length += 1
                          if(recipe.items.recipe.recipe_sides.length > 0) {
                            sideName = recipe.items.recipe.recipe_sides[0].recipe.name
                          }
                          const rcpClassName = sideName !== "" ? 'select-meals-title-cntnt' : 'select-meals-title-cntnt no-side'
                          return(
                            <div 
                              className={`meal-post ${cDate.cooking_date}${rIndex}`}
                              key={`meal-post ${cDate.cooking_date}${rIndex}`} 
                              draggable="true"
                              style={{border}}
                              name={`meal-post${cDate.cooking_date}${rIndex}`}
                              id={length}
                              onDragStart={(event)=>this.startDrag(event, recipe, cDate, rIndex)}
                              onDragOver={(event)=>this.dragCapture(event)}
                              onDrop={(event)=>this.onDrop(event,recipe,cDate,'old' ,length, rIndex)}
                              onDragEnd={(event)=>{this.onDragEnd(event,cDate.cooking_date, rIndex)}}
                            
                            >
                              <a 
                                className={`testio ${cDate.cooking_date}${rIndex}`} 
                                style={{display:'none'}} 
                                id={length}
                                draggable="false"
                                onDragLeave={(event)=>{this.dragLeaveEvent(event,cDate.cooking_date, rIndex)}}  
                              />
                              <a 
                                className={`meal-post${cDate.cooking_date}${rIndex}`}
                                onClick={()=>{popupIndex === -1 && this.showRecipe(recipe, true, rIndex)}}
                                ref={`meal-post${cDate.cooking_date}${rIndex}`}
                                id={length}
                                onDragOver={(event)=>this.dragCapture(event)}
                                onDragOverCapture={(event)=>this.dropEffect(event,cDate.cooking_date, rIndex,length)}
                              > 
                                <Popover
                                  placement={position}
                                  container={document.body}
                                  hideWithOutsideClick={false}
                                  // eslint-disable-next-line react/no-string-refs
                                  target={this.refs[`meal-post${cDate.cooking_date}${rIndex}`]}
                                  show={showRecipePopup && rIndex === popupIndex}
                                  style={style}
                                  containerStyle={containerStyle}
                                  onHide={()=>this.handleClose()} >
                                  {
                                    showRecipePopup && rIndex === popupIndex &&
                                    this.quickView(cDate.cooking_date, recipeIds)
                                  }
                                </Popover>
                                
                                <div>
                                  <LazyLoad
                                    loaderImage
                                    originalSrc={rcpImg}
                                    offsetLeft={window.innerWidth}
                                    offsetHorizontal={360}
                                    height={92}
                                    id={length}
                                    imageProps={{
                                      src: '/images/small.png',
                                      draggable: false,
                                      name: 'd.',
                                      id:length
                                    }}
                                    className='recipe_img'
                                    
                                  />
                                </div>
                                <div className={rcpClassName} id={length}>
                                  <h5 id={length}>{recipe.items.recipe.name}</h5>
                                  { sideName !== "" && <p className="aftr-hdng" id={length}>{sideName}</p>}
                                </div>
                              </a>
                            </div>
                        
                          )}
                        return null
                      })
                    }
                    {mode === 'edit' && 
                      <div className="notes-section">
                        <span className="add-notes" onClick={()=>this.props.showNotes(notesDate, mode, cDate.notes, index)}>
                          <b>Notes: </b>
                          {cDate.notes && cDate.notes.content}
                        </span>
                      </div>
                    }
                    <div className={`add-rcp meal-post ${cDate.cooking_date} ${length}`} 
                      onDragOver={(event)=>this.dragCapture(event)}
                      onDragOverCapture={(event)=>this.addDragCapture(event, cDate.cooking_date, length)}
                      onDragLeave={(event)=>{this.addDragLeaveEvent(event,cDate.cooking_date, length)}}
                      onDrop={(event)=>this.onDrop(event,'',cDate, "new", length,recipeArr.length)}
                      id={length}
                    >
                      <div className="rcp-btn">
                        <button onClick={()=>this.props.addNewRecipe(cDate.cooking_date,length)} > 
                          <span>
                            <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                              <title>88ACA598-6101-414C-8774-1EA5AE604D29</title>
                              <desc>Created with sketchtool.</desc>
                              <g id="Calendar-Design" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                <g id="View-Details:-Adjust-Servings-1" transform="translate(-952.000000, -687.000000)" fillRule="nonzero">
                                  <g id="Modal" transform="translate(773.000000, 264.000000)">
                                    <g id="Servings:-Edit-Active" transform="translate(0.000000, 413.500000)">
                                      <g id="Icon-/-Action-/-Servings-/-Add" transform="translate(179.000000, 9.500000)">
                                        <circle id="Oval-2" stroke="#979797" fill="#FFFFFF" cx="10" cy="10" r="9.5" />
                                        <path d="M10,5 L10,15" id="Line-6" stroke="#979797" strokeLinecap="square" />
                                        <path d="M5,10 L15,10" id="Line-3" stroke="#979797" strokeLinecap="square" />
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </g>
                            </svg>
                            Recipe
                          </span> 
                        </button>
                        <button onClick={()=>this.props.showNotes(notesDate, mode, cDate.notes, index)}>
                          <span>
                            <svg className="notes" width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      
                              <title>DC804DE8-AFE8-40F5-A154-5E9137121B46</title>
                              <desc>Created with sketchtool.</desc>
                              <defs>
                                <path d="M0.7,10.6753645 L0.7,13.3 L3.32463547,13.3 L11.0655603,5.55907513 L8.44092487,2.93443966 L0.7,10.6753645 Z M13.0952788,3.52935706 C13.3682409,3.25639497 13.3682409,2.81545621 13.0952788,2.54249412 L11.4575062,0.904721569 C11.1845441,0.631759477 10.7436054,0.631759477 10.4706433,0.904721569 L9.18982115,2.18554369 L11.8144566,4.81017919 L13.0952788,3.52935706 Z" id="path-1" />
                              </defs>
                              <g id="Aug-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                <g id="M-Dashboard-1-Copy" transform="translate(-246.000000, -1576.000000)">
                                  <g id="Add-Notes-Chip-Copy-3" transform="translate(234.000000, 1570.000000)">
                                    <g id="Icon-/-Action-/-Edit" transform="translate(12.000000, 6.000000)">
                                      <mask id="mask-2" fill="white">
                                        <use xlinkHref="#path-1" />
                                      </mask>
                                      <use id="Edit" fill="#979797" fillRule="nonzero" xlinkHref="#path-1" />
                                    </g>
                                  </g>
                                </g>
                              </g>
                            </svg>
                            Notes 
                          </span>
                        </button>
                      </div>
                    </div>
                    
                  </div>
                </div>
              </div>
            )
          })
        }
      </div>
    )
  }

  quickView(cDate, recipeIds) {
    
    const { 
      recipeData, clickInstructionAccordion, showInstructions, showEdit,
      clickIngredientAccordion, showIngredients, updatedServing, message
    } = this.state
    const equipmentIcn = `/images/${recipeData.items.recipe.recipe_equipment_type[0].equipment_type.icon}`
    let sideName = ""
    const totalServing = totalValue(recipeIds, recipeData.items.recipe.recipe_id)
    if(recipeData.items.recipe.recipe_sides.length > 0) {
      sideName = recipeData.items.recipe.recipe_sides[0].recipe.name
    }
    const serveText = recipeData.servingSize > 1 ? 'servings' : 'serving'
    
    
    return(
      <div className="recipe-popover">
        {this.actionButton(recipeData, sideName, totalServing,cDate)}
        <div className="rcp-img">
          <img src={recipeData.items.recipe.image} alt="" />
        </div>
        <div className="rcp-quk-detail">
          <div className="rcp-row rcp-header">
            <div className="rcp-icn"> <img src={equipmentIcn}  alt="euiqpment"/> </div>
            <div className="rcp-nm">
              <h2 onClick={()=>this.viewRecipe(recipeData,recipeData.items.recipe.name, sideName, totalServing )}>{recipeData.items.recipe.name}</h2>
              {sideName !=="" && <p className="side">{sideName}</p>}
            </div>
          </div>
          <div className={!clickIngredientAccordion ? "rcp-row dtil" : "rcp-row dtil active"}>
            <div className="rcp-icn"> <img src="/images/ingredients.svg"  alt="euiqpment"/> </div>
            <div className="rcp-nm">
              <p  onClick={()=> this.clickAccordion('ingredients')}>Ingredients
                { !clickIngredientAccordion ?
                  <i className="fa fa-angle-down" />
                  :
                  <i className="fa fa-angle-up" />
                }
              </p>
            </div>
          </div>
          <div key='ingredients' className={`showlist${showIngredients}`}>
            <p className="serving-info">Shown for {updatedServing} serving only. 
              <span onClick={()=>this.viewRecipe(recipeData,recipeData.items.recipe.name, sideName, totalServing )}>
                View 
              </span> 
               details to see all</p>
            { recipeData.items.recipe.recipe_ingredients.length > 0 &&
                recipeData.items.recipe.recipe_ingredients.map((value) => {
                  let quantity = value.quantity;
                  quantity *= (updatedServing / 4);
                  
                  let a = 0;
                  quantity = quantity.toString().split('.');
                  quantity[0] = parseInt(quantity[0], 0);
                  if (quantity[0] === 0) {
                    quantity[0] = '';
                  }
                  if (quantity.length > 1 && quantity[1] !== '00') {
                    quantity[1] = `${0}.${quantity[1]}`;
                    a = fraction(parseFloat(quantity[1]));
                    if (a.d > 0) {
                      a.d = Math.round(a.d / a.n);
                      a.n = 1;
                    }
                  }
                  if (a !== 0 && a.d > 1) {
                    a = ReactHtmlParser(`${quantity[0]}<sup>${a.n}</sup>&frasl;<sub>${a.d}</sub>`);
                  } else if (a !== 0) {
                    a = a.n;
                  } else {
                    a = quantity[0];
                  }
                  
                  return (
                    <ul key={value.ingredient.name}>
                      <li key={value.id}>
                        {a} {value.unit} {value.ingredient.name }
                      </li>
                    </ul>
                  );
                })
            }
          </div>
            
          <div className={!clickInstructionAccordion ? "rcp-row dtil" : "rcp-row dtil active"}>
            <div className="rcp-icn"> 
              <i className="fa fa-list-ol" />
            </div>
            <div className="rcp-nm">
              <p  onClick={()=> this.clickAccordion('instructions')}> Directions
                { !clickInstructionAccordion ?
                  <i className="fa fa-angle-down" />
                  :
                  <i className="fa fa-angle-up" />
                }
              </p>
            </div>
          </div>
          <div className={`instructions showlist${showInstructions}`}>
            <ol>
              { recipeData.items.recipe.recipe_instructions.length > 0 &&
                  recipeData.items.recipe.recipe_instructions.map(value => (
                    <li key={value.id}>
                      {ReactHtmlParser(value.instruction) }
                    </li>
                  ))
              }
            </ol>
          </div>
          <div className="rcp-row tim">
            <div className="rcp-icn"> <img src="/images/time.svg"  alt="euiqpment"/> </div>
            <div className="rcp-nm">
              <p>{recipeData.totalHands} Hands On</p>
              <span>{recipeData.totalTime} Total Cook Time</span>
            </div>
          </div>
        </div>
        <div className="rcp-servng-detail">
          <div className="servng-meal">
            <h3>Meal {serveText} :&nbsp; 
              {showEdit ?
                <ul className="set-serving">		
                  <li>
                    <a className="mb-hide red-circle" onClick={()=>this.setServing(recipeData.servingSize, 'sub')}>
                      <SubIcon />
                    </a>
                  </li>
                
                  <li> {recipeData.servingSize} </li>
                
                  <li>
                    <a className="mb-hide Green-circle" onClick={()=>this.setServing(recipeData.servingSize, 'add')}>
                      <PlusIcon />
                    </a>
                  </li>
                </ul>
                : 
                recipeData.servingSize
              }
            </h3>
            <span>Total for this week : {totalServing} </span>
          </div>
          <div className="edt-section">
            { !showEdit  ?
              <button className="edit" onClick={()=>this.showEdit()}>Edit</button>
              :
              message === "" ?
                <button className="save" onClick={()=>this.saveServing(cDate)}> Save </button>
                :
                <span className="colr">{message}</span>
            }
          </div>
        </div>
      </div>
    )
  }

  saveServing(cDate) {
    const { 
      recipeArr, recipeData, popupIndex, showIngredients, showInstructions, 
      clickIngredientAccordion, clickInstructionAccordion, updatedServing
    } = this.state
    let sideDishId = ""
    if(recipeData.items.recipe.recipe_sides && recipeData.items.recipe.recipe_sides.length > 0) {
      sideDishId = recipeData.items.recipe.recipe_sides[0].recipe.id
    }
    const params = {
      delete: [],
      update: [{
        id:recipeData.items.recipe.id,
        recipe_id:recipeData.items.recipe.recipe_id,
        side_dish_id:sideDishId,
        serving_size: recipeData.servingSize
      }],
      add: [],
      deleted_cooking_ids:[]
    }
    this.setState({ updatedServing: recipeData.servingSize})
    const rData = {
      showRecipePopup:true ,
      popupIndex,
      clickInstructionAccordion,
      clickIngredientAccordion,
      showInstructions,
      showIngredients,
      recipeData,
      updatedServing
    }

    this.props.editServing(params, cDate, recipeArr, rData)
  }

  showEdit() {
    const { showEdit } = this.state
    this.setState({ showEdit: !showEdit})
  }

  // view recipe detail function
  viewRecipe(recipe, rname, sname, totalServing) {
    const { 
      popupIndex, showRecipePopup, clickInstructionAccordion, 
      clickIngredientAccordion, showInstructions, showIngredients, updatedServing
    } = this.state
    
    
    const rData = {
      showRecipePopup,
      popupIndex,
      clickInstructionAccordion,
      clickIngredientAccordion,
      showInstructions,
      showIngredients,
      recipeData: recipe,
      servSize: updatedServing
    }
    // const serving = sessionStorage.setItem()
    this.props.viewRecipe(recipe, rname, sname, totalServing, rData)
  }

  deleteRecipe(recipeData) {
    this.setState({ showDelete: true, showRecipePopup: false, recipeData})
  }

  actionButton(recipeData, sideName, totalServing,cDate) {
    const { popupIndex } = this.state
    return(
      <div className="action-btn">
        <div className="lft-view-btn" onClick={()=>this.viewRecipe(recipeData,recipeData.items.recipe.name, sideName, totalServing )}>
          <img src="/images/eye.svg" alt="" />
          <span>View</span>
        </div>
        <div className="rgt-btn">
          {/* <div className="round-brdr"><img src="/images/Duplicate.svg" alt="" /></div> */}
          <div className="round-brdr" title="Swap recipe" onClick={()=>this.props.swapRecipe(popupIndex)}><img src="/images/swapbtn.svg" alt="" /></div>
          <div className="round-brdr" title="Delete recipe" onClick={()=>this.deleteRecipe(recipeData, cDate)}><img src="/images/del.svg" alt="" /></div>
          <div className="round-brdr" title="Close" onClick={()=>this.closePopup()}><img src="/images/clos.svg" alt="" className="cross" /></div>
        </div>
      </div>
    )
  }

  closePopup() {
    const { showIngredients, showInstructions, clickIngredientAccordion, clickInstructionAccordion } = this.state
    const rData = {
      popupIndex:-1,
      showIngredients, showInstructions, clickIngredientAccordion, clickInstructionAccordion
    }
    this.setState({ showEdit: false })
    this.props.closePopup(rData)
  }

  cancelDelete() {
    this.setState({ showDelete: false})
  }

  confirmDelete(index, id, recipeId) {
    this.cancelDelete()
    this.props.deleteRecipe(index, id, recipeId)
  }

  setServing(size,action){
    const { 
      popupIndex, recipeData, clickInstructionAccordion, clickIngredientAccordion,
      showInstructions, showIngredients 
    } = this.state
    const rData = {
      showRecipePopup:true ,
      popupIndex,
      clickInstructionAccordion,
      clickIngredientAccordion,
      showInstructions,
      showIngredients,
      recipeData,
    }
    if(action === "add") {
      this.props.addServing(popupIndex, size, rData)
    } else {
      this.props.removeServing(popupIndex, size, rData)
    }
  }

  handleClose() {
    const { showRecipePopup } = this.state
    if(showRecipePopup)
      this.setState({ showRecipePopup: false, popupIndex: -1})
  }
  
  render() {
    const { cookingDate, showDelete , recipeData, popupIndex } = this.state
    return(
      <div>
        {
          cookingDate.length >0  && this.viewPlan()
        }
        {
          showDelete && 
          <div>
            <DeletePopup 
              cancelDelete={(recipe,index)=>this.cancelDelete(recipe,true,index)}
              deleteRecipe={(index, id, recipeId)=>this.confirmDelete(index, id, recipeId)}
              recipeData={recipeData}
              popupIndex={popupIndex}
            />
            <div className="modal-backdrop fade in " />
          </div>
        }
      </div>
    )
  }
}

export default RecipeForWeekCalendar


// WEBPACK FOOTER //
// ./src/components/dashboard/RecipeForWeekCalendar.js